import './config/polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/client'
import { Provider } from 'react-redux'
import { client, waitOnCache } from 'graphql/client'
import Router from 'router'
import Localization from 'components/LayoutComponents/Localization'
import getAuth0config from 'config'
import { Auth0Provider } from 'config/react-auth0-spa'
import { handleAppException } from 'utils/error'
import { store, history } from 'config/store'
import { initGA, initFirebase } from 'analytics'
import swConfig from 'config/swConfig'

// app styles
import './global.scss'
import * as serviceWorker from './serviceWorker'

// Global error handling
window.addEventListener('error', (e) => handleAppException(e))

// Initialize Google Analytics
initGA(history)
const firebaseAnalytics = initFirebase(history)

waitOnCache.then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <Auth0Provider {...getAuth0config(history)}>
        <ApolloProvider client={client}>
          <Localization>
            <Router history={history} />
          </Localization>
        </ApolloProvider>
      </Auth0Provider>
    </Provider>,
    document.getElementById('root'),
  )
})

serviceWorker.register(swConfig)

// eslint-disable-next-line import/prefer-default-export
export { firebaseAnalytics }
